module.exports = __webpack_public_path__ + "static/media/om_eyeshape_round_amber.afc33ac3.png";